export enum ViewType {
    TABLE = "Table",
    CHART = "Chart"
}
  